module.exports = __webpack_public_path__ + "media/newstyle/images/lp-banner-b-desktop-8f49a75c674c56283b76975a2182aa40.png";